import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { api } from "@/lib/api";

const KEY = "alr_bk_entity";
const TABS = [["Overview", "/bookkeeping"], ["Review queue", "/bookkeeping/review"], ["Matching", "/bookkeeping/matching"], ["Rules", "/bookkeeping/rules"], ["Receipts", "/bookkeeping/receipts"], ["Connections", "/bookkeeping/connections"], ["QuickBooks mapping", "/bookkeeping/qbo-mapping"], ["Transactions", "/bookkeeping/transactions"], ["Entity mapping", "/bookkeeping/mapping"], ["Job log", "/bookkeeping/jobs"]];

export function useBkEntities() {
  const [entities, setEntities] = useState(null);
  const [error, setError] = useState("");
  const [entityId, setEntityIdState] = useState(() => localStorage.getItem(KEY) || "alr_llc");
  const reload = () => api("/bookkeeping/entities").then(setEntities).catch((e) => setError(e.message));
  useEffect(() => { reload(); }, []);
  const setEntityId = (id) => { localStorage.setItem(KEY, id); setEntityIdState(id); };
  return { entities, error, entityId, setEntityId, reload, entity: entities?.find((e) => e.id === entityId) };
}

export const EntitySwitcher = ({ entities, entityId, onChange }) => (
  <div className="flex flex-wrap gap-2" data-testid="bk-entity-switcher">
    {(entities || []).map((e) => {
      const on = e.id === entityId;
      return (
        <button key={e.id} onClick={() => onChange(e.id)} data-testid={`bk-entity-${e.id}`}
          className="rounded-full border px-4 py-1.5 text-xs font-extrabold transition-colors"
          style={on ? { background: "#4CCC06", color: "#000", borderColor: "#4CCC06" } : { color: "#D4D4D4", borderColor: "#333" }}>
          {e.name}
        </button>
      );
    })}
  </div>
);

export const BkTabs = () => (
  <nav className="flex gap-4 overflow-x-auto border-b border-[#262626]" data-testid="bk-tabs">
    {TABS.map(([label, to]) => (
      <NavLink key={to} to={to} end data-testid={`bk-tab-${label.toLowerCase().replace(/\s+/g, "-")}`}
        className={({ isActive }) => `-mb-px border-b-2 pb-2 text-sm font-bold ${isActive ? "border-[#4CCC06] text-white" : "border-transparent text-neutral-400 hover:text-white"}`}>
        {label}
      </NavLink>
    ))}
  </nav>
);
